<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'code')">{{ schema.fields.code.label }}</th>
        <th v-if="canSee(schema, 'description')">
          {{ schema.fields.description.label }}
        </th>
        <th v-if="canSee(schema, 'active_start_date')">
          {{ schema.fields.active_start_date.label }}
        </th>
        <th v-if="canSee(schema, 'active_end_date')">
          {{ schema.fields.active_end_date.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'code')">
          <o-widget-wrapper
            :schema="schema"
            name="code"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].code"
              :form-state="formState"
              name="code"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.code"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'description')">
          <o-widget-wrapper
            :schema="schema"
            name="description"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].description"
              :form-state="formState"
              name="description"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.description"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'active_start_date')">
          <o-widget-wrapper
            :schema="schema"
            name="active_start_date"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].active_start_date"
              name="active_start_date"
              v-bind="schema.fields.active_start_date"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'active_end_date')">
          <o-widget-wrapper
            :schema="schema"
            name="active_end_date"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].active_end_date"
              name="active_end_date"
              v-bind="schema.fields.active_end_date"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../../vue-ocom/mixins";
import OItemEditableTable from "../../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../../vue-ocom/components/layout/OSection";

export default {
  name: "UserRoleFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("UserRole"),
    CreateCodeTableFetchMixin([]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.UserRole,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.UserRole),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>